export default __webpack_public_path__ + "static/media/facebook.f974a62c.svg";